import { defineComponent as t, openBlock as r, createBlock as n, withCtx as a, renderSlot as d } from "vue";
import { ButtonComp as l } from "./ButtonComp.js";
const i = /* @__PURE__ */ t({
  __name: "RouterButtonComp",
  props: {
    disabled: Boolean
  },
  setup(o) {
    return (e, p) => (r(), n(l, {
      routerLink: "",
      disabled: o.disabled
    }, {
      default: a(() => [
        d(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled"]));
  }
});
export {
  i as RouterButtonComp
};
//# sourceMappingURL=RouterButtonComp.js.map
